import { __RouterContext } from 'react-router';
import { useContext } from 'react';
export function useRouter() {
    return useContext(__RouterContext);
}
//# sourceMappingURL=useRouter.js.map